import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
    OtherLanguageServices,
    LanguageExpertiseServices,
    SupportedLanguages,
    QualityAssurance,
} from "./components";

const OurServices = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
        });
        window.scrollTo(0, 0);
        document.title = "Our Services | NKENNE AI";
    }, []);

    return (
        <main className="w-full flex flex-col relative bg-white">
            {/* 1. Other Language Services Showcase */}
            <OtherLanguageServices />

            {/* 2. Supported Languages Section */}
            <SupportedLanguages />

            {/* 3. Languages Expertise Beyond Translation (Services 01 - 07) */}
            <LanguageExpertiseServices />

            {/* 4. Quality Assurance Section */}
            <QualityAssurance />
        </main>
    );
};

export default OurServices;
